import { TableLayoutModifierDialogTabs } from '@aibees/shared/features/advance-table/components/table-layout-modifier-dialog/components/table-layout-modifier-dialog-tabs';
import { classnames } from '@aibees/shared/utils';
import { Stack } from '@mui/material';
import { memo } from 'react';
import { TableLayoutModifierDialogFooter } from './components/table-layout-modifier-dialog-footer';
import { TableLayoutTemplateCreateForm } from './components/table-layout-template-create-form';
import * as Styled from './styles';
import * as SX from './sx';
import type { TableLayoutModifierDialogProps as Props } from './types';

export const TableLayoutModifierDialog = memo(
  ({
    className,
    element,
    managementPopoverState,
    transferListPopoverState,
  }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('TableLayoutModifierDialog', className)}
        sx={SX.root}
        state={managementPopoverState}
        element={element}
      >
        <Stack gap={1.5}>
          <TableLayoutTemplateCreateForm
            managementPopoverState={managementPopoverState}
            transferListPopoverState={transferListPopoverState}
          />
          <TableLayoutModifierDialogTabs />
          <Stack direction="row" justifyContent="flex-end" gap={1}>
            <TableLayoutModifierDialogFooter
              dialogState={managementPopoverState}
            />
          </Stack>
        </Stack>
      </Styled.Wrapper>
    );
  }
);

TableLayoutModifierDialog.displayName = 'TableLayoutModifierDialog';
